/* Weekly deal countdown, shared by the Deal of the Week section and the product page.
   Starts every [data-deal-countdown] element once. Data attributes:
   data-end            fixed end (ISO date); wins over the weekly schedule
   data-weekly-day     0-6 (Sunday = 0), or "none"
   data-weekly-hour    0-23; the deal ends at hour:59:59
   data-timezone       IANA name, DST-aware (falls back to data-store-offset, e.g. "-0400")
   data-expired-text   shown when it ends; blank hides the element
   data-expired-class  class added when the expired text is shown */
(function () {
  // Offset (minutes) of an IANA timezone at a given instant, DST-aware.
  function tzOffset(ts, tz) {
    try {
      var parts = {};
      new Intl.DateTimeFormat('en-US', {
        timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      }).formatToParts(new Date(ts)).forEach(function (x) { parts[x.type] = x.value; });
      var asUTC = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
      return Math.round((asUTC - Math.floor(ts / 1000) * 1000) / 60000);
    } catch (e) {
      return null;
    }
  }

  // "-0400" -> -240 minutes; fallback when Intl timezone support is missing.
  function offsetMinutes(z) {
    var m = /^([+-])(\d{2})(\d{2})$/.exec(z || '');
    if (!m) return 0;
    var mins = parseInt(m[2], 10) * 60 + parseInt(m[3], 10);
    return m[1] === '-' ? -mins : mins;
  }

  // Next occurrence of weekday/hour:59:59 in the store's timezone, as a UTC timestamp.
  function nextWeeklyEnd(day, hour, tz, fallbackOffset) {
    var now = Date.now();
    var offNow = tzOffset(now, tz);
    if (offNow === null) offNow = fallbackOffset;
    var local = new Date(now + offNow * 60000);
    var target = new Date(local.getTime());
    target.setUTCHours(hour, 59, 59, 0);
    target.setUTCDate(target.getUTCDate() + ((day - local.getUTCDay() + 7) % 7));
    if (target <= local) target.setUTCDate(target.getUTCDate() + 7);
    // Convert wall-clock target to UTC using the offset in force at the target (handles DST changes).
    var guess = target.getTime() - offNow * 60000;
    var offTarget = tzOffset(guess, tz);
    if (offTarget === null) offTarget = offNow;
    return target.getTime() - offTarget * 60000;
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function start(el) {
    if (el.dataset.countdownStarted) return;
    el.dataset.countdownStarted = 'true';

    var end = NaN;
    if (el.dataset.end) {
      end = Date.parse(el.dataset.end);
    } else if (el.dataset.weeklyDay && el.dataset.weeklyDay !== 'none') {
      end = nextWeeklyEnd(
        parseInt(el.dataset.weeklyDay, 10),
        parseInt(el.dataset.weeklyHour, 10),
        el.dataset.timezone,
        offsetMinutes(el.dataset.storeOffset)
      );
    }
    if (isNaN(end)) return;

    var units = {};
    el.querySelectorAll('[data-unit]').forEach(function (u) {
      units[u.dataset.unit] = u;
    });

    var timer;
    function tick() {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (left === 0) {
        clearInterval(timer);
        if (el.dataset.expiredText) {
          el.textContent = el.dataset.expiredText;
          if (el.dataset.expiredClass) el.classList.add(el.dataset.expiredClass);
        } else {
          el.hidden = true;
        }
        return;
      }
      units.d.textContent = Math.floor(left / 86400);
      units.h.textContent = pad(Math.floor((left % 86400) / 3600));
      units.m.textContent = pad(Math.floor((left % 3600) / 60));
      units.s.textContent = pad(left % 60);
    }

    el.hidden = false;
    tick();
    timer = setInterval(tick, 1000);
  }

  function init() {
    document.querySelectorAll('[data-deal-countdown]').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run when the theme editor re-renders a section.
  document.addEventListener('shopify:section:load', init);
})();
